module.exports = __webpack_public_path__ + "img/consejos.f02b96f5.jpg";